<style scoped src="../../../css/selector-base.less" lang="less"></style>
<style lang="less" scoped>
  .select-item-container{
    overflow: auto;
    max-height: 160px;
  }
</style>
<template>
  <div class="item-selector">
    <Poptip @on-popper-show="poperShow" placement="bottom" :width="width" :transfer="transfer">
      <i-button class="selector-btn" :class="{'type-text': type === 'text'}" :type="type" :size="size" long :disabled="disabled">
        <slot>
          <span class="color-grey">选择...</span>
        </slot>
      </i-button>
      <div class="pop-tip-content" v-show="!disabled" slot="content">
        <i-input class="search-area" v-model="search_text" search placeholder="搜索... 可使用拼音 yj => 押金/佣金，yajin => 押金，yongjin => 佣金"></i-input>
        <Spin fix v-if="loading"></Spin>
        <div class="select-item-container" v-else>
          <div class="select-item"
               :class="{'select-item-disabled': item.id === value}"
               @click="setItem(item)"
               v-for="item in searched_items"
               :key="item.id">
            <span>{{item.full_name}}</span>
            <span class="color-error" v-if="check_link_report && !item.v2_fet_id">[未关联报表]</span>
          </div>
        </div>
      </div>
    </Poptip>
  </div>
</template>
<script>
  import ExpenseTypeUtil from '../../expense_type/libs/util';
  export default {
    props: {
      value: {
        type: Number
      },
      type: {
        type: String
      },
      size: {
        type: String
      },
      width: {
        type: [Number, String],
        default: 400
      },
      transfer: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // 检查费用类别是否关联了仪表盘对应的费用类别
      // 如果设置了未关联的费用类别, 会导致仪表盘数据不准
      check_link_report: {
        type: Boolean,
        default: true
      },
    },
    data(){
      return {
        search_text: '',
        items: [],
        loading: false
      }
    },
    computed: {
      searched_items(){
        let items = [];
        if(this.search_text){
          this.items.forEach((item)=>{
            const text = item.full_name + item.pinyin;
            if(text.indexOf(this.search_text) > -1){
              items.push(item);
            }
          });
          return items;
        }else{
          return this.items;
        }
      }
    },
    created(){
      //
    },
    mounted(){
      //
    },
    methods: {
      poperShow(){
        if(this.items.length === 0){
          this.getUsedExpenseTypes();
        }
      },
      getUsedExpenseTypes(){
        if(this.loading) return;
        this.loading = true;
        this.items = [];
        ExpenseTypeUtil.getUsedLastGenerationTypes().then((data)=>{
          data.expense_types.forEach((type)=>{
            this.items.push(type);
          });
        }).catch((e)=>{
          this.$Modal.error({title:'错误', content: e.message});
        }).finally(()=>{
          this.loading = false;
        })
      },
      setItem(item){
        if(this.check_link_report && !item.v2_fet_id ){
          this.$Message.error({title: '提示', content: '该费用类别未设置[报表对应关系], 不能选择!请联系罗阳'});
          return;
        }
        // if(!item.is_sync_pay_bill && !item.is_sync_other_payable) {
        //     this.$Message.error({title: '提示', content: '该费用类别未设置[单据传递方式]，不能选择！'});
        //     return;
        // }
        this.$emit('input', item.id);
        this.$emit('on-change', item);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      }
    }
  }
</script>
